<template>
    <el-popover trigger="hover" placement="top">
        <template>
            <el-table
                ref="fileTable"
                :data="fileTableData"
                :row-style="setRowStyle"
                @row-click="fileDownload"
                @row-contextmenu="filePreview"
                style="width: 100%">
                    <el-table-column
                    prop="fileName"
                    label="点击下载,鼠标右键点击预览"
                    :formatter="filePopFormatter"
                    width="180">
                    </el-table-column>
            </el-table>
        </template>
        <div slot="reference" class="name-wrapper">
            <el-tag size="medium">{{ cellValue }}</el-tag>
        </div>
    </el-popover>
</template>

<script>
    import { API_FILE_DOWNLOAD } from '@/common/constants';
    import { downloadFiles } from '@/data-model';
    import { getPreviewFileUrl } from '@/utils/grocer';
    export default {
        data () {
            return {
            };
        },
        props: {
            isShowOverflowTooltip: {
                type: Boolean,
                default: false
            },
            column: {
                type: Object
            },
            cellValue: {
                type: String,
                default: ''
            },
            fileTableData: { // 列表数据
                type: Array
            },
            tableColumns: { // 列表中需要显示的字段
                type: Array
            },
            subformTableColumns: { // 列表中需要显示的字段
                type: Array
            },
            isSubform: { // 是否需要子表单的合并效果
                type: Boolean,
                default: false
            }
        },
        created () {

        },
        methods: {
            filePopFormatter (row, column, cellValue, index) {
                return row.fileName;
            },
            setRowStyle (row) {
                return 'cursor: pointer;';
            },
            showDown (obj) {
                let isEditAuth = false;
                if (obj.createdBy) {
                    let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    if (obj.createdBy === currentUserInfo.userId) {
                        isEditAuth = true;
                    } else {
                        if (currentUserInfo) {
                            let resources = currentUserInfo.resources;
                            if (resources) {
                                for (let i = 0; i < resources.length; i++) {
                                    if (resources[i].resourceUrl === 'formFileDownload') { // 是否可以点击报表进行数据修改
                                        isEditAuth = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                } else {
                    isEditAuth = true;
                }
                return isEditAuth;
            },
            showPrev (obj) {
                let isEditAuth = false;
                if (obj.createdBy) {
                    let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                    let currentUserInfo = JSON.parse(currentUserStr);
                    if (obj.createdBy === currentUserInfo.userId) {
                        isEditAuth = true;
                    } else {
                        if (currentUserInfo) {
                            let resources = currentUserInfo.resources;
                            if (resources) {
                                for (let i = 0; i < resources.length; i++) {
                                    if (resources[i].resourceUrl === 'formFilePreview') { // 是否可以点击报表进行数据修改
                                        isEditAuth = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                } else {
                    isEditAuth = true;
                }
                return isEditAuth;
            },
            async fileDownload (row, column, event) {
                let res = await this.showDown(row);
                if (res) {
                    let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                    url = url + '&operationType=1';
                    this.download(url);
                } else {
                    this.$message.error('没有权限');
                }
            },
            async filePreview (row, column, event) {
                let res = await this.showPrev(row);
                if (res) {
                    window.event.returnValue = false;
                    // let operationType = '&operationType=2';
                    let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                    let index = url.lastIndexOf('.');
                    let fileType = url.substr(index);
                    if (fileType === '.png' || fileType === '.PNG' ||
                        fileType === '.pdf' || fileType === '.PDF' ||
                        fileType === '.JPG' || fileType === '.jpg' ||
                        fileType === '.JPEG' || fileType === '.jpeg' ||
                        fileType === '.BMP' || fileType === '.bmp' ||
                        fileType === '.GIF' || fileType === '.gif' ||
                        fileType === '.TXT' || fileType === '.txt') {
                        let tempwindow = window.open();
                        url = url + '&operationType=2';
                        tempwindow.location = url;
                    } else if (fileType === '.doc' || fileType === '.docx' || fileType === '.xls' || fileType === '.xlsx' || fileType === '.ppt' || fileType === '.pptx') {
                        let previewUrl = await getPreviewFileUrl(row);
                        if (previewUrl) {
                            let tempwindow = window.open();
                            tempwindow.location = previewUrl;
                        }
                    } else {
                        this.$message.error('此格式文件不支持预览');
                    }
                } else {
                    this.$message.error('没有权限');
                }
            },
            download (url) {
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            }
        }
    };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicFileColumn.vue